






































































































import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Buttons from "@/components/Buttons.vue";
import Promotion from "@/components/Promotion.vue";

@Component({
  components: {
    Buttons,
    Navbar,
    Footer,
  },
})
export default class Garantias extends Vue {
    selectedCar : string = '';

    costosDeServicio={
      'GRANDVITARABG': [
            ["5,000","3","$1,963.00"],
            ["10,000","6","$3,502.00"],
            ["20,000","12","$3,628.00"],
            ["30,000","18","$3,657.00"],
            ["40,000","24","$5,288.00"],
            ["50,000","30","$3,502.00"],
            ["60,000","36","$3,784.00"],
            ["70,000","42","$4,688.00"],
            ["80,000","48","$6,166.00"],
            ["90,000","54","$6,161.00"],
            ["100,000","60","$4,815.00"],
        ],
        'FRONXBG': [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,628.00"],
            ["30,000","18","$3,421.00"],
            ["40,000","24","$5,288.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$3,784.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,166.00"],
            ["90,000","54","$5,925.00"],
            ["100,000","60","$4,815.00"],
        ],
        'BALENOGLS': [
            ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,547.00"],
            ["40,000","24","$5,186.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,090.00"],
            ["90,000","54","$4,547.00"],
            ["100,000","60","$4,712.00"],
        ],
        'BALENOGLX':[
            ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,547.00"],
            ["40,000","24","$5,186.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,090.00"],
            ["90,000","54","$4,547.00"],
            ["100,000","60","$4,712.00"],
        ],
        'CIAZGLX2021': [  
              ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
            
        ],
        "ERTIGAGLS": [ 
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,547.00"],
            ["40,000","24","$5,186.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,090.00"],
            ["90,000","54","$4,547.00"],
            ["100,000","60","$4,712.00"],
        ],      

        "ERTIGAGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,547.00"],
            ["40,000","24","$5,186.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,090.00"],
            ["90,000","54","$4,547.00"],
            ["100,000","60","$4,712.00"],
        ],
        "ERTIGAXL7": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,265.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,547.00"],
            ["40,000","24","$5,186.00"],
            ["50,000","30","$3,265.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$4,452.00"],
            ["80,000","48","$6,090.00"],
            ["90,000","54","$4,547.00"],
            ["100,000","60","$4,712.00"],
        ],
        "IGNISGLS": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "IGNISGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "JIMNYGLX" : [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "SCROSSBOOSTERJET": [
            ["5,000","3","$2,315.00"],
            ["10,000","6","$3,642.00"],
            ["20,000","12","$4,138.00"],
            ["30,000","18","$4,766.00"],
            ["40,000","24","$4,138.00"],
            ["50,000","30","$3,642.00"],
            ["60,000","36","$7,169.00"],
            ["70,000","42","$3,642.00"],
            ["80,000","48","$5,998.00"],
            ["90,000","54","$4,766.00"],
            ["100,000","60","$5,324.00"],
        ],
        "SCROSSGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "SWIFTBOOSTERJET": [
            ["5,000","3","$2,315.00"],
            ["10,000","6","$3,642.00"],
            ["20,000","12","$4,509.00"],
            ["30,000","18","$4,766.00"],
            ["40,000","24","$4,509.00"],
            ["50,000","30","$3,642.00"],
            ["60,000","36","$6,644.00"],
            ["70,000","42","$3,642.00"],
            ["80,000","48","$6,319.00"],
            ["90,000","54","$4,766.00"],
            ["100,000","60","$5,696.00"],
        ],
        "SWIFTGLS": [
            ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "SWIFTGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
        ],
        "SWIFTBOOSTERGREENGLS": [
            ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$3,447.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$3,681.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$5,950.00"],
            ["100,000","60","$4,712.00"],
           
        ],
        "SWIFTBOOSTERGREENGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$3,447.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$3,681.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$5,950.00"],
            ["100,000","60","$4,712.00"],
        ],
        "SWIFTSPORTBOOSTERJET": [
            ["5,000","3","$2,315.00"],
            ["10,000","6","$3,642.00"],
            ["20,000","12","$4,796.00"],
            ["30,000","18","$4,766.00"],
            ["40,000","24","$4,796.00"],
            ["50,000","30","$3,642.00"],
            ["60,000","36","$7,456.00"],
            ["70,000","42","$3,642.00"],
            ["80,000","48","$6,606.00"],
            ["90,000","54","$4,766.00"],
            ["100,000","60","$5,983.00"],
           
        ],
        "VITARABOOSTERJET": [
        ["5,000","3","$2,315.00"],
            ["10,000","6","$3,642.00"],
            ["20,000","12","$4,138.00"],
            ["30,000","18","$4,766.00"],
            ["40,000","24","$4,138.00"],
            ["50,000","30","$3,642.00"],
            ["60,000","36","$7,169.00"],
            ["70,000","42","$3,642.00"],
            ["80,000","48","$5,998.00"],
            ["90,000","54","$4,766.00"],
            ["100,000","60","$5,324.00"],
           
        ],
        "VITARAGLX": [
        ["5,000","3","$1,963.00"],
            ["10,000","6","$3,291.00"],
            ["20,000","12","$3,526.00"],
            ["30,000","18","$4,572.00"],
            ["40,000","24","$3,999.00"],
            ["50,000","30","$3,291.00"],
            ["60,000","36","$4,807.00"],
            ["70,000","42","$3,291.00"],
            ["80,000","48","$5,809.00"],
            ["90,000","54","$4,572.00"],
            ["100,000","60","$4,712.00"],
           
        ],
        
    };

    imagenesCarros = {
    "BALENOGLS": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/baleno.png'] ,
    "GRANDVITARABG": ['https://d17f75hnd3uun3.cloudfront.net/models/158/PQ111X400017700M4/colors/GVSGsec9_1705042068557_1730964075908.webp'] ,
    "FRONXBG": ['https://d17f75hnd3uun3.cloudfront.net/models/157/3LF1CXN00027700M4/colors/FRXBIsec9_1706004681125.png'] ,
    "BALENOGLX": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/baleno.png'] ,
    "CIAZGLX2021": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2021/CIAZ.png?v=1'],
    "ERTIGAGLS": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-boostergreen.png'],
    "ERTIGAGLX":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-boostergreen.png'] ,
    "ERTIGAXL7":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-xl7.png?v=1'] ,
    "IGNISGLS": ['https://cdn.marciano.space/suzuki/cars/2021/IGNIS.png'],
    "IGNISGLX": ['https://cdn.marciano.space/suzuki/cars/2021/IGNIS.png'],
    "JIMNYGLX":['https://d17f75hnd3uun3.cloudfront.net/models/145/6GG1BCH00AB71M3/colors/JimnyVerde_1729688028766.webp'] ,
    "SCROSSBOOSTERJET": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/s-cross.png?v=2'],
    "SCROSSGLX":['https://cdn.marciano.space/suzuki/cars/scross.png'] ,
    "SWIFTBOOSTERJET":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTGLS":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTGLX":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTBOOSTERGREENGLS":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2022/swift-booster-green.png'] ,
    "SWIFTBOOSTERGREENGLX": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2022/swift-booster-green.png'],
    "SWIFTSPORTBOOSTERJET": ['https://cdn.marciano.space/suzuki/cars/swift-sport.png'] ,
    "VITARABOOSTERJET": ['https://cdn.marciano.space/suzuki/cars/vitara.png'] ,
    "VITARAGLX": ['https://cdn.marciano.space/suzuki/cars/vitara.png'] ,
    };
}
